import { StyleSheet } from 'aphrodite';
import { SPACE, THEME } from '../../../../web/components-v2/Theme/theme';
import { shadowMd } from '../../../../web/styles/shadows';

const { colors, common, typography } = THEME;

export const styleSheet = StyleSheet.create({
	container: {
		paddingBottom: SPACE[40],
	},

	filter: {
		alignItems: 'center',
		display: 'flex',
		gap: SPACE[20],
		maxWidth: 1100,
	},
	filterDate: {
		width: 260,
	},
	filterUser: {
		width: 280,
	},
	filterSpacer: {
		flex: 1,
	},
	unpaidLabel: {
		color: colors.text.main,
		cursor: 'pointer',
		fontSize: typography.fontSizes.sm,
		whiteSpace: 'nowrap',
	},

	list: {
		display: 'flex',
		flexDirection: 'column',
		gap: SPACE[16],
		maxWidth: 1100,
		paddingTop: SPACE[20],
	},
	loadingSpinner: {
		marginTop: SPACE[32],
	},

	card: {
		alignItems: 'center',
		backgroundColor: colors.background.light,
		border: `1px solid ${colors.border.light}`,
		borderRadius: common.borderRadius,
		boxShadow: shadowMd,
		boxSizing: 'border-box',
		gap: SPACE[16],
		display: 'grid',
		gridTemplateColumns: '200px 80px 250px 170px 1fr 80px',
		padding: `${SPACE[24]}px ${SPACE[28]}px`,
	},
	cardName: {
		color: colors.text.main,
		fontSize: typography.fontSizes.sm,
		fontWeight: typography.fontWeights.bold,
		whiteSpace: 'nowrap',
	},
	cardPrize: {
		color: colors.success.dark,
		fontFamily: typography.fontFamilies.sora,
		fontSize: typography.fontSizes.md,
		fontWeight: typography.fontWeights.bold,
	},
	cardSymbols: {
		alignItems: 'center',
		display: 'flex',
		gap: SPACE[4],
	},
	symbolChip: {
		alignItems: 'center',
		backgroundColor: colors.background.main,
		border: `1px solid ${colors.border.light}`,
		borderRadius: common.borderRadius,
		boxSizing: 'border-box',
		display: 'inline-flex',
		height: SPACE[32],
		justifyContent: 'center',
		width: SPACE[32],
	},
	cardText: {
		color: colors.text.main,
		fontSize: typography.fontSizes.sm,
		whiteSpace: 'nowrap',
	},
	cardTextTitle: {
		color: colors.text.light,
	},
	cardPaid: {
		justifySelf: 'end',
	},
	paidLabel: {
		color: colors.text.main,
		cursor: 'pointer',
		fontSize: typography.fontSizes.sm,
	},
});
